(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["industrial-case-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-case-directory]';
    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
    const normalize = (value) => String(value || '').normalize('NFKC').trim().toLocaleLowerCase();

    const initialize = (root) => {
      if (!root || root.dataset.caseDirectoryReady === 'true') return;
      root.dataset.caseDirectoryReady = 'true';

      const body = root.querySelector('[data-case-rows]');
      if (!body) return;

      const rows = Array.from(body.querySelectorAll('[data-case-row]'));
      const filters = Array.from(root.querySelectorAll('[data-case-filter]'));
      const sortButtons = Array.from(root.querySelectorAll('[data-case-sort]'));
      const clearButtons = Array.from(root.querySelectorAll('[data-case-clear]'));
      const count = root.querySelector('[data-case-count]');
      const noResults = root.querySelector('[data-case-no-results]');
      const tableWrap = root.querySelector('.industrial-case-directory__table-wrap');
      const countTemplate = root.dataset.countTemplate || 'Showing [visible] of [total] projects';
      let activeSort = '';
      let direction = 'ascending';

      const originalIndex = (row) => Number(row.dataset.originalIndex || 0);
      const initialSortOrder = (row) => {
        const value = Number(row.dataset.sortOrder);
        return Number.isFinite(value) && row.dataset.sortOrder !== '' ? value : null;
      };

      rows.sort((left, right) => {
        const leftOrder = initialSortOrder(left);
        const rightOrder = initialSortOrder(right);
        if (leftOrder !== null && rightOrder !== null && leftOrder !== rightOrder) return leftOrder - rightOrder;
        if (leftOrder !== null && rightOrder === null) return -1;
        if (leftOrder === null && rightOrder !== null) return 1;
        return originalIndex(left) - originalIndex(right);
      });
      rows.forEach((row) => body.append(row));
      rows.forEach((row, index) => {
        row.dataset.stableIndex = String(index);
      });

      const markSized = (frame) => {
        const media = frame.querySelector('video, img');
        if (!media) return;
        const apply = () => {
          const width = media.tagName === 'VIDEO' ? media.videoWidth : media.naturalWidth;
          if (width > 0) frame.classList.add('is-sized');
        };
        if (media.tagName === 'VIDEO') {
          if (media.readyState >= 1) apply();
          else media.addEventListener('loadedmetadata', apply, { once: true });
        } else if (media.complete) {
          apply();
        } else {
          media.addEventListener('load', apply, { once: true });
        }
      };

      root.querySelectorAll('.industrial-case-directory__frame').forEach(markSized);

      const stopPlayer = (frame) => {
        if (!frame || frame.dataset.playing !== 'true') return;
        const video = frame.querySelector('video');
        if (video) {
          video.pause();
          video.controls = false;
        }
        frame.dataset.playing = 'false';
        frame.classList.remove('is-playing');
        const button = frame.querySelector('[data-case-play]');
        if (button) button.hidden = false;
      };

      const playFrame = (frame) => {
        const video = frame?.querySelector('video');
        if (!video || frame.dataset.playing === 'true') return;
        if (!video.src.startsWith('https://')) return;
        root.querySelectorAll('[data-case-player]').forEach((other) => {
          if (other !== frame) stopPlayer(other);
        });
        video.controls = true;
        video.playsInline = true;
        frame.dataset.playing = 'true';
        frame.classList.add('is-playing');
        const button = frame.querySelector('[data-case-play]');
        if (button) button.hidden = true;
        video.play().catch(() => {});
      };

      const update = () => {
        let visible = 0;
        const filterValues = Object.fromEntries(
          filters.map((filter) => [filter.dataset.caseFilter, normalize(filter.value)])
        );

        rows.forEach((row) => {
          const matches = Object.entries(filterValues).every(([key, value]) => {
            if (!value) return true;
            const datasetKey = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
            return normalize(row.dataset[datasetKey]) === value;
          });
          row.hidden = !matches;
          if (!matches) {
            const frame = row.querySelector('[data-case-player]');
            if (frame) stopPlayer(frame);
          }
          if (matches) visible += 1;
        });

        if (count) {
          count.textContent = countTemplate
            .replace('[visible]', String(visible))
            .replace('[total]', String(rows.length));
        }

        const hasFilters = filters.some((filter) => filter.value !== '');
        clearButtons.forEach((button) => {
          if (button.closest('[data-case-no-results]')) return;
          button.hidden = !hasFilters;
        });

        if (noResults) noResults.hidden = visible !== 0;
        if (tableWrap) tableWrap.hidden = visible === 0;
      };

      const setSort = (button) => {
        const key = button.dataset.caseSort;
        if (activeSort === key) {
          direction = direction === 'ascending' ? 'descending' : 'ascending';
        } else {
          activeSort = key;
          direction = 'ascending';
        }

        sortButtons.forEach((item) => {
          const heading = item.closest('th');
          const directionText = item.querySelector('[data-sort-direction]');
          const isActive = item === button;
          heading.setAttribute('aria-sort', isActive ? direction : 'none');
          if (directionText) {
            directionText.textContent = isActive ? `, ${direction}` : '';
          }
        });

        rows.sort((left, right) => {
          const datasetKey = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
          const comparison = collator.compare(left.dataset[datasetKey] || '', right.dataset[datasetKey] || '');
          if (comparison !== 0) return direction === 'ascending' ? comparison : -comparison;
          return Number(left.dataset.stableIndex) - Number(right.dataset.stableIndex);
        });
        rows.forEach((row) => body.append(row));
        update();
      };

      root.addEventListener('click', (event) => {
        const button = event.target.closest('[data-case-play]');
        if (!button || !root.contains(button)) return;
        const frame = button.closest('[data-case-player]');
        if (frame) playFrame(frame);
      });
      filters.forEach((filter) => filter.addEventListener('change', update));
      sortButtons.forEach((button) => button.addEventListener('click', () => setSort(button)));
      clearButtons.forEach((button) => {
        button.addEventListener('click', () => {
          filters.forEach((filter) => {
            filter.value = '';
          });
          update();
          filters[0]?.focus();
        });
      });

      update();
    };

    const initializeAll = (scope = document) => {
      if (scope.matches?.(selector)) initialize(scope);
      scope.querySelectorAll?.(selector).forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    if (!window.caseDirectorySectionListener) {
      window.caseDirectorySectionListener = true;
      document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
